import type { SfContext } from "@amzn/d16-g-client-deck-builder-typescript-client";
import type { AsyncStatus } from "@react-hookz/web";

import { zustandStore } from "./zustand.helpers";

export interface SalesforceActions {
    setSfContext: (sfContext: SfContext) => void;
    setAsyncStatus: (asyncStatus: AsyncStatus) => void;
    resetState: () => void;
}

export interface SalesforceState {
    sfContext: SfContext;
    asyncStatus: AsyncStatus;
}

export const initialState: SalesforceState = {
    sfContext: {
        locale: "",
        vertical: "",
        subvertical: "",
    },
    asyncStatus: "not-executed",
};

export const { store: salesforceStore } = zustandStore<
    SalesforceState,
    SalesforceActions
>("sfContext", initialState, (set, get) => ({
    setSfContext: (sfContext: SfContext) => set(() => ({ sfContext })),
    setAsyncStatus: (asyncStatus: AsyncStatus) =>
        set(() => {
            const state = get();
            return { ...state, asyncStatus };
        }),
    resetState: () => set(() => ({ ...initialState })),
}));
